/**
 * Adapptio Editor
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import { useEffect } from "react";
import { Key } from "ts-key-enum";

/**
 * Sets up global key down event listener when active
 * Usable for catching simple keys such as ESC or command, alt.
 * Do not use instead of key binding service for key combinations.
 *
 * @param onClick On click handler
 * @param active If to listen to clicks
 */
export function useEscKey(onEscKey: (ev: globalThis.KeyboardEvent) => void, active: boolean): void {
	useEffect(() => {
		if (!active) {
			return;
		}

		const handleKeyDown = (ev: globalThis.KeyboardEvent) => {
			if (ev.key === Key.Escape) {
				onEscKey(ev);
			}
		};

		document.body.addEventListener("keydown", handleKeyDown);

		return () => {
			document.body.removeEventListener("keydown", handleKeyDown);
		};
	}, [ active ]);
}
